import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { TrailState } from './types'
import { RootState } from '../types'

export const state: TrailState = {
  dataLoading: false,
  dataGeoreferenceLoading: false,
  markerHighlighted: -1,
  queryTimestamp: -1,
  thing: {},
  thingPage: 1,
  trailLocations: [],
  trailLocationByPage: [],
  trailArr: [],
  locations: [],
  lastPointTrailLocations: null,
  boundsLocations: null,
  locationsWithEvents: [],
  thingTrailSummary: {
    distance: -1,
    max_speed: -1,
    time_in_movement: -1,
    time_stopped: -1,
    time_with_contact_off: -1,
    fuel_consumption: -1,
    max_temperature: -1
  },
  showEvents: true,
  filterActive: false,
  geoReference: [],
  prevNonNullOdometer: null,
  totalDistance: 0,
  prevNonNullCandata: null,
  totalOdoliter: 0,
  thingGpsID: '',
  hideGreeting: true,
  prevNonNullIgnitionStatus: null,
  prevNonNullMainPowerOn: null
}

const namespaced = true

export const trailState: Module<TrailState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
